import type { BariPreReferralData } from '@common/validation/customControls/bariPre/bariPreReferral/v1/bariPreReferralSchemaV1';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { initialData } from './bariPreReferralData';
import { BariPreReferralEdit } from './BariPreReferralEdit';
import { BariPreReferralRead } from './BariPreReferralRead';

CustomControlRegistry.instance.register<BariPreReferralData>({
    EditElement: BariPreReferralEdit,
    ReadElement: BariPreReferralRead,
    canCopyReadSections: true,
    code: CustomControlCode.BariPreReferral,
    initialData,
    version: 1,
});
